import installationInstructions from './installationInstructions';

const pekPlugContent = {
  installationInstructions
}

export { pekPlugContent };
